<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-10-09 17:08:29
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container" v-loading="loading">
        <div class="pageTitle">添加入库</div>
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <el-tab-pane label="直接添加" name="first">
                <el-form ref="form2" :model="form2" :rules="rules2" label-width="120px">
                    <el-form-item label="入库单号:" prop="stock_in_sn">
                        <el-col :span="8">
                            <el-input v-model="form2.stock_in_sn"></el-input>
                        </el-col>
                    </el-form-item>
                        <el-form-item label="自定义单号:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form2.customize_sn" ></el-input>
                    </el-col>
                </el-form-item>
                    <el-form-item label="产品信息:" prop="product_sn">
                        <el-col :span="4">
                            <el-input v-model="form2.product_sn" readonly></el-input>
                        </el-col>
                        <el-col class="line" :span="1" style="text-align: center">-</el-col>
                        <el-col :span="8">
                            <el-input v-model="form2.product_name" readonly class="readonlyclass"></el-input>
                        </el-col>
                        <el-col :span="4" style="margin-left: 20px">
                            <el-button type="primary" @click="selectProduct()">选择</el-button>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="产品条码:" prop="product_bar_code">
                        <el-col :span="8">
                            <el-input v-model="form2.product_bar_code" readonly class="readonlyclass" ></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="生产批次号:" prop="production_batch">
                        <el-col :span="8">
                            <el-input v-model="form2.production_batch"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="数量:" prop="stock_in_num">
                        <el-col :span="8">
                            <el-input v-model="form2.stock_in_num" type="number"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="生产日期">
                        <el-col :span="8">
                            <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    v-model="form2.production_date"
                                    @change="selectStart"
                                    style="width: 100%;"
                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="有效期至">
                        <el-col :span="8">
                            <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    v-model="form2.expiring_date"
                                    style="width: 100%;"
                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="入库仓库:" prop="warehouse_sn">
                        <el-select  v-model="form2.warehouse_sn" size="small">
                            <el-option v-for=" i in addArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                       :value="i.warehouse_sn"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form2.remarks" ></el-input>
                    </el-col>
                </el-form-item>
                    <el-form-item>
                        <el-col :span="8">
                            <el-button type="primary" @click="save('form2')">保存</el-button>
                        </el-col>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
              
            <!-- -->
            <el-tab-pane label="扫描二维码" name="second"   v-if='customer_id=="10000044"'>
                <el-form ref="form1" :model="form1" :rules="rules1" label-width="120px">
                    <el-form-item label="入库单号:" prop="stock_in_sn">
                        <el-col :span="8">
                            <el-input v-model="form1.stock_in_sn"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="自定义单号:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form1.customize_sn" ></el-input>
                    </el-col>
                </el-form-item>
                    <el-form-item label="产品二维码:">
                        <el-col :span="8">
                            <el-input v-model="form1.pCode" @keyup.enter.native="searchFun"></el-input>
                        </el-col>
                        <el-col :span="8" style="margin-left: 20px">
                            <span style="color: #ccc">扫描二维码自动获取下方信息</span><span  style="margin-left: 10px;font-size: 18px;color:green;cursor: pointer" @click="example()">二维码示例</span>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="生产批次号:" prop="production_batch">
                        <el-col :span="8">
                            <el-input v-model="form1.production_batch" readonly class="readonlyclass"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="产品编号:" prop="product_sn">
                        <el-col :span="8">
                            <el-input v-model="form1.product_sn" readonly class="readonlyclass"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="产品名称:" prop="product_name">
                        <el-col :span="8">
                            <el-input v-model="form1.product_name" readonly class="readonlyclass"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="条码:" prop="product_bar_code">
                        <el-col :span="8">
                            <el-input v-model="form1.product_bar_code" readonly class="readonlyclass"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="数量:" prop="stock_in_num">
                        <el-col :span="8">
                            <el-input v-model="form1.stock_in_num" readonly type="number" class="readonlyclass"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="生产日期">
                        <el-col :span="8">
                            <el-date-picker
                                    type="date"
                                    v-model="form1.production_date"
                                    style="width: 100%;"
                                    class="readonlyclass"
                                    readonly
                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="有效期至">
                        <el-col :span="8">
                            <el-date-picker
                                    type="date"
                                    v-model="form1.expiring_date"
                                    class="readonlyclass"
                                    style="width: 100%;"
                                    readonly
                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="入库仓库:" prop="warehouse_sn">
                        <el-select v-model="form1.warehouse_sn" size="small">
                            <el-option v-for=" i in scanArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                       :value="i.warehouse_sn"></el-option>
                        </el-select>

                        <!--<el-select v-model="form1.warehouse_sn" placeholder="请选择入库仓库">
                          <el-option label="区域一" value="shanghai"></el-option>
                          <el-option label="区域二" value="beijing"></el-option>
                        </el-select>-->
                    </el-form-item>
                    <el-form-item label="备注:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form1.remarks" ></el-input>
                    </el-col>
                </el-form-item>
                    <el-form-item>
                        <el-col :span="8">
                            <el-button type="primary" @click="sacnSave('form1')">保存</el-button>
                        </el-col>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
             <el-tab-pane label="入库扫描" name="three"  >
                <instockScan />
            </el-tab-pane>
        </el-tabs>
        <selectProduct
                v-if="dialogVisible"
                v-on:handleClose="dialogVisible = false"
                v-on:pushData="getChildData"
        ></selectProduct>
        <codeDialog
                v-if="codeDialog"
                v-on:handleClose="codeDialog = false"
        >

        </codeDialog>
    </div>
</template>

<script>
    import selectProduct from "./selectProduct.vue";
    import codeDialog  from './codeDialog'
    import { Message } from 'element-ui';
       import VueCookie from 'vue-cookie'
    import instockScan from './instockScan'
    export default {
        name: "addInstock",
        data() {
            return {
                loading:false,
                codeDialog:false,
                activeName2: "first",
                scanArray: [],//扫描二维码仓库
                addArray: [],//直接添加仓库
                form1: {
                    product_category_id:'',
                    stock_in_sn: "",//入库单号
                    pCode: "",
                    production_batch: '',
                    product_sn: '',
                    product_name: '',
                    production_date: '',
                    expiring_date: '',
                    product_bar_code: '',
                    stock_in_num: '',
                    brand_name:'',
                    manufacturer:'',
                    product_unit:'',
                    product_specs:'',
                    approval_number:'',
                    warehouse_sn:'',
                       remarks:"",
                    customize_sn:""//自定义单号
                },
                form2: {
                    stock_in_sn: "",
                    production_batch: '',//产品生产批次
                    product_sn: '',//产品编号
                    product_name: '',//产品名称
                    stock_in_num: '',//入库数量
                    product_bar_code: '',//产品条码
                    production_date: '',//生产日期
                    expiring_date: '',//有效期至
                    warehouse_sn: '',//仓库编号
                    remarks:'',
                    approval_number:'',//批准文号
                    brand_name:'',//品牌名称
                    manufacturer:'',
                    product_specs:'',
                    product_unit:'',
                    is_edit:false,
                    customize_sn:""//自定义单号
                },
                //表单验证规则
                rules1: {
                    stock_in_sn: [
                        {required: true, message: '入库单号不能为空！',}
                    ],
                    product_sn: [
                        {required: true, message: '产品信息不能为空！',}
                    ],
                    product_name:[
                        {required: true, message: '产品信息不能为空！',}
                    ],
                    /*product_bar_code: [
                        {required: true, message: '产品条码不能为空！',}
                    ],*/
                    production_batch: [
                        {required: true, message: '生产批次号不能为空', trigger: 'blur'}
                    ],
                    stock_in_num: [
                        { required: true, message: '入库数量不能空'}
                    ],
                    /*warehouse_sn: [
                        {required: true, message: '请选择仓库', trigger: 'change'}
                    ]*/
                },

                rules2: {
                    stock_in_sn: [
                        {required: true, message: '入库单号不能为空！',}
                    ],
                    product_sn: [
                        {required: true, message: '产品信息不能为空！',}
                    ],
                    /*product_bar_code: [
                        {required: true, message: '产品条码不能为空！',}
                    ],*/
                    production_batch: [
                        {required: true, message: '生产批次号不能为空', trigger: 'blur'}
                    ],
                    stock_in_num: [
                        { required: true, message: '入库数量不能空'}
                    ],
                    warehouse_sn: [
                        {required: true, message: '请选择仓库', trigger: 'change'}
                    ]
                },
                expirationtime: '',//产品的有效时间，单位是月
                product_id: 0,//选择的产品的id
                dialogVisible: false,
                isrequired:true,
                customer_id:""
            };
        },
        methods: {
        
            init(){
                this.customer_id=VueCookie.get('customer_id')
            },
            
            //获取基础配置(生产批次号的控制是否为必填)
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    
                    if(res.data.production_batch_on_off == 0){
                        this.rules1.production_batch = [];
                        this.rules2.production_batch = [];
                    }else if(res.data.production_batch_on_off == 1){
                        this.rules1.production_batch = [
                            {required: true, message: '生产批次号不能为空'}
                        ];
                        this.rules2.production_batch = [
                            {required: true, message: '生产批次号不能为空', trigger: 'blur'}
                        ]
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //扫描事件
            searchFun(event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    let infoArr = [];
                    infoArr = this.form1.pCode.split(',');
                    this.form1.production_batch = infoArr[2];
                    this.form1.product_sn = infoArr[0];
                    this.form1.product_bar_code = infoArr[5];
                    this.form1.stock_in_num = infoArr[1];
                    this.form1.production_date = infoArr[3];
                    this.form1.expiring_date = infoArr[4];
                    let url = '/products/' + infoArr[0];
                    this.$get('logistics', url, {
                        product: this.form1.product_sn
                    }).then(res => {
                        this.form1.product_category_id=res.data.product_category_id 
                        this.form1.product_name = res.data.product_name;
                        this.form1.brand_name = res.data.brand_name;
                        this.form1.manufacturer = res.data.manufacturer;
                        this.form1.product_unit = res.data.product_unit
                        this.form1.product_specs = res.data.product_specs;
                        this.form1.approval_number = res.data.approval_number
                    }).catch(function (error) {
                        console.log(error);
                        
                    });

                }
            },
            /*生成随机的单号*/
            randomCode() {
                var randomNum = Math.floor(Math.random() * 9999);
                var myDate = new Date();
                var tY = myDate.getFullYear();
                var tM = myDate.getMonth() + 1;
                if (tM >= 1 && tM <= 9) {
                    tM = "0" + tM;
                }
                var tD = myDate.getDate();
                if (tD >= 1 && tD <= 9) {
                    tD = "0" + tD;
                }
                var hour = myDate.getHours(); // 时
                var minutes = myDate.getMinutes(); // 分
                var seconds = myDate.getSeconds() //秒
                if (hour >= 0 && hour <= 9) {
                    hour = "0" + hour;
                }
                if (minutes >= 0 && minutes <= 9) {
                    minutes = "0" + minutes;
                }
                if (seconds >= 0 && seconds <= 9) {
                    seconds = "0" + seconds;
                }
                this.form1.stock_in_sn = 'RK' + tY + tM + tD + hour +minutes + seconds + randomNum;
                this.form2.stock_in_sn = 'RK' + tY + tM + tD + hour +minutes + seconds + randomNum;
            },
            //二维码示例
            example(){
            this.codeDialog = true;
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            //扫描二维码
            scan() {
            },
            //选择产品
            selectProduct() {
                this.dialogVisible = true;
            },
            //获取仓库列表(扫二维码)
            getScanStock() {
                this.$get('logistics', '/warehouses.all', {
                    lang: ''
                }).then(res => {
                    this.scanArray = res.data;
                    this.addArray = res.data;
                    for(var i = 0; i < res.data.length;i++){
                        if(res.data[i].is_default == 1){
                            this.form2.warehouse_sn = res.data[i].warehouse_sn;
                            this.form1.warehouse_sn = res.data[i].warehouse_sn;
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //直接添加获取子组件传过来的产品信息
            getChildData(val) {
                console.log(val);
                this.expirationtime = val.expirationtime;
                this.product_id = val.product_id;
                this.form2.product_bar_code = val.product_bar_code;
                this.form2.product_sn = val.product_sn;
                this.form2.product_name = val.product_name;
                this.form2.production_date = '';
                this.form2.expiring_date = '';
                this.form2.brand_name = val.brand_name;
                this.form2.manufacturer = val.manufacturer;
                this.form2.product_specs = val.product_specs;
                this.form2.product_unit = val.product_unit;
                this.form2.approval_number = val.approval_number;
                this.form2.product_category_id =val.product_category_id 
                this.form1.product_category_id =val.product_category_id 

                /*remarks  approval_number  brand_name  manufactuer*/
            },
            //选择生产日期
            selectStart(val) {
                let statTime = this.moment(val).format("YYYY-MM-DD");
                // expirationtime
                this.form2.expiring_date = this.calculateTime(statTime, this.expirationtime );
                this.$forceUpdate()
            },
            //根据选择的开始时间和有效期来判断有效期至
            calculateTime(date, monthNum) {
                var dateArr = date.split('-');
                var year = dateArr[0]; //获取当前日期的年份
                var month = dateArr[1]; //获取当前日期的月份
                var day = dateArr[2]; //获取当前日期的日
                var days = new Date(year, month, 0);
                days = days.getDate(); //获取当前日期中的月的天数
                var year2 = year;
                var month2 = parseInt(month) + parseInt(monthNum);
                if (month2 > 12) {
                    year2 = parseInt(year2) + parseInt((parseInt(month2) / 12 == 0 ? 1 : parseInt(monthNum) / 12));
                    if(parseInt(month2) % 12==0){
                    month2 = 12;
                    }else{
                    month2 = parseInt(month2) % 12;
                    }
                }
                var day2 = day;
                var days2 = new Date(year2, month2, 0);
                days2 = days2.getDate();
                if (day2 > days2) {
                    day2 = days2;
                }
                if (month2 < 10) {
                    month2 = '0' + month2;
                }
                var t2 = year2 + '-' + month2 + '-' + day2;
                return this.getNextDate(t2,-1);
            },
             getNextDate(date,day) {  
            var dd = new Date(date);
            dd.setDate(dd.getDate() + day);
            var y = dd.getFullYear();
            var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
            return y + "-" + m + "-" + d;
            },

            //扫面二维码保存
            sacnSave(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let beginstr = '', endstr = '';
                        if (this.form1.production_date) {
                            beginstr = this.moment(this.form1.production_date).format("YYYY-MM-DD")
                        }
                       if(this.form2.expiring_date){
                             endstr = this.moment(this.form2.expiring_date).format("YYYY-MM-DD");
                         }
                        this.loading = true;
                        this.$post('logistics', '/inwarehouses', {
                            warehouse_sn: this.form1.warehouse_sn,
                            stock_in_sn: this.form1.stock_in_sn,
                            production_batch: this.form1.production_batch,
                            product_id: this.product_id,
                            product_sn: this.form1.product_sn,
                            product_unit: this.form1.product_unit,
                            product_specs: this.form1.product_specs,
                            product_category_id :this.form1.product_category_id ,
                            product_name: this.form1.product_name,
                            stock_in_num: this.form1.stock_in_num,
                            product_bar_code: this.form1.product_bar_code,
                            production_date: beginstr,
                            expiring_date: endstr,
                            brand_name:this.form1.brand_name,
                            manufacturer:this.form1.manufacturer,
                            approval_number:this.form1.approval_number,
                             remarks:this.form1.remarks,
                                customize_sn:this.form1.customize_sn
                        }).then(res => {
                            this.loading = false;
                            if (res.message == '操作成功') {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'instockManage'
                                });
                            }
                        }).catch(error =>{
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //直接保存
            save(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.form2.stock_in_num  == 0){
                            Message.error('数量不能为0')
                            return false;
                        }
                        let beginstr = '', endstr = '';
                        if (this.form2.production_date) {
                            beginstr = this.moment(this.form2.production_date).format("YYYY-MM-DD")
                        }
                        if(this.form2.expiring_date){
                             endstr = this.moment(this.form2.expiring_date).format("YYYY-MM-DD");
                         }
                        this.loading = true;
                        this.$post('logistics', '/inwarehouses', {
                            warehouse_sn: this.form2.warehouse_sn,
                            stock_in_sn: this.form2.stock_in_sn,
                            production_batch: this.form2.production_batch,
                            product_id: this.product_id,
                                   product_category_id :this.form2.product_category_id ,
                            product_sn: this.form2.product_sn,
                            product_name: this.form2.product_name,
                            stock_in_num: this.form2.stock_in_num,
                            product_bar_code: this.form2.product_bar_code,
                            production_date: beginstr,
                            expiring_date: endstr,
                            brand_name: this.form2.brand_name,
                            manufacturer :this.form2.manufacturer,
                            product_specs : this.form2.product_specs,
                            product_unit : this.form2.product_unit,
                            approval_number : this.form2.approval_number,
                              remarks:this.form2.remarks,
                                customize_sn:this.form2.customize_sn
                        }).then(res => {
                            this.loading = false;
                            if (res.message == '操作成功') {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'instockManage'
                                });
                            }
                        }).catch(error =>{
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        },
        created() {
            this.randomCode();
            this.getScanStock();
            this.getConfigInfo();
            this.init()
        },
        components: {
            selectProduct,codeDialog,instockScan
        }
    };
</script>

<style lang="scss" scoped>
    .readonlyClass{
        background-color: #eee !important;
    }
</style>